export default __webpack_public_path__ + "static/media/paquetexpress-logo.8dd38370.png";